export const advanceFundSearchConst = {
    CONTENT_UNAVAILABLE: "CONTENT_UNAVAILABLE",
    CONTENT_AVAILABLE: "CONTENT_AVAILABLE"
};